import { css } from "styled-components";
import { colors } from "styles";

export type appointmentStatusEnum =
  | "aguardando"
  | "carregando"
  | "finalizado"
  | "no show"
  | "cancelado";
export type appointmentStatusEnumUnloading =
  | "aguardando"
  | "descarregando"
  | "finalizado"
  | "no show"
  | "cancelado";

export const appointmentStatus = {
  aguardando: css`
    background-color: ${colors.midBlue};
    color: white;
  `,
  carregando: css`
    background-color: ${colors.yellow};
    color: white;
  `,
  finalizado: css`
    background-color: ${colors.darkPetrol};
    color: white;
  `,
  "no show": css`
    background-color: ${colors.orange};
    color: white;
  `,
  cancelado: css`
    background-color: ${colors.red};
    color: white;
  `,
};
